import classes from './sidebars.module.css';

export type SectionHeadingProps = { title: string };

const SectionHeading = ({ title }: SectionHeadingProps) => (
  <div className={classes.sectionHeading}>{title}</div>
);

export default SectionHeading;
